import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { ENetworkFlag } from '../../../model/application/ENetworkFlag';
import { IStoreReplicationResponse } from '../../../model/store/IStoreReplicationResponse';
import { StoreTask } from './StoreTask';
import { TaskDescriptor } from './TaskDescriptor';
import { IStoreTaskParams } from 'apps/idl/src/model/backgroundTask';

export class DbSyncTask<T extends IStoreTaskParams> extends StoreTask<T> {

	//#region FIELDS

	private msDbId: string;

	//#endregion

	//#region METHODS

	constructor(poDescriptor: TaskDescriptor<T>) {
		super(poDescriptor);
		this.msDbId = this.descriptor.params.dbId;
	}

	/** @override */
	public execTask(): Observable<IStoreReplicationResponse> {
		return this.msvcFlag.waitForFlag(ENetworkFlag.isOnlineReliable, true)
			.pipe(
				mergeMap(() => this.msvcStore.replicateToServer(this.msDbId))
			);
	}

	//#endregion
}